<template>
    <div class="language-picker">
        <div @click="toggleMenu()" class="selected-language">
            <img
                :src="flagUrl(selectedLanguage.slug)"
                class="flag"
                :width="24"
                :height="16"
                :alt="selectedLanguage.name"
            />

            <span class="lang-code">{{ selectedLanguage.code }} </span>

            <svg
                :style="{
                    transform: menuOpened ? 'rotate(180deg)' : 'rotate(0deg)',
                }"
                aria-hidden="true"
                class="chevron"
                focusable="false"
                data-prefix="fas"
                data-icon="chevron-down"
                role="img"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 448 512"
            >
                <path
                    fill="currentColor"
                    d="M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z"
                ></path>
            </svg>
        </div>

        <ul class="language-list__menu" v-if="menuOpened">
            <li class="menu__item" v-for="(lang, i) in languagesList" :key="i">
                <a
                    class="menu__link"
                    :href="
                        lang.code === $globalConstants.host.lang
                            ? '/'
                            : '/' + lang.code
                    "
                >
                    <img
                        :src="flagUrl(lang.slug)"
                        class="flag"
                        :width="24"
                        :height="16"
                        :alt="lang.name"
                    />
                    {{ lang.label }}
                </a>
            </li>
        </ul>
    </div>
</template>

<script>
import { mediaQueriesMixin } from '@/mixins';
import { languages } from '@/constants/languages';
export default {
    name: 'LanguagePicker',
    mixins: [mediaQueriesMixin],
    props: {
        languageOptions: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            languages: languages,
            menuOpened: false,
            selectedLanguage:
                languages[this.$globalConstants.host.language_code],
        };
    },
    computed: {
        languagesList() {
            const matches = [];
            const languages = this.languageOptions.filter(
                (el) => el !== this.$globalConstants.host.language_code
            );
            for (let i = 0; i < languages.length; i++) {
                const lang = this.languages[languages[i]];
                if (!lang) continue;
                matches.push(lang);
            }
            return matches;
        },
    },
    methods: {
        toggleMenu() {
            this.menuOpened = !this.menuOpened;
        },
        flagUrl(lang) {
            return `${this.$globalConstants.imageUrl}/img/languages/flags/${lang}.png?d=30x20`;
        },
    },
};
</script>

<style lang="scss" scoped>
@import '@/sass/mixins';

.language-picker {
    position: relative;
    z-index: 1;
    .selected-language {
        display: flex;
        font-weight: bold;
        cursor: pointer;
        color: var(--text-color);
        gap: 6px;
        @include mq('tablet-wide') {
            font-weight: normal;
            &:hover {
                opacity: 0.9;
            }
        }

        .lang-code {
            width: max-content;
            text-transform: uppercase;
        }

        .chevron {
            display: inline;
            width: 10px;
        }
    }

    .language-list__menu {
        position: absolute;
        width: fit-content;
        display: grid;
        grid-template-rows: repeat(10, auto);
        right: -38px;
        grid-auto-columns: 160px;
        top: calc(100% + 34px);
        padding: 0;
        background: #ffffff;
        box-shadow: 2px 2px 16px rgba(0, 0, 0, 0.25);
        border-radius: 6px;
        grid-auto-flow: column;
        list-style-type: none;

        .menu__item {
            overflow: hidden;
            &:nth-child(1) {
                border-start-start-radius: 6px;
                border-start-end-radius: 6px;
            }
            &:last-child {
                border-end-start-radius: 6px;
                border-end-end-radius: 6px;
            }
            &:hover {
                background: #e8f8ff;
            }

            .menu__link {
                color: #246aa8;
                display: flex;
                align-items: center;
                justify-content: flex-start;
                gap: 9px;
                padding: 8px 16px;
                line-height: 24px;
            }
        }

        .menu__item::before {
            content: '';
            position: absolute;
            top: -10px;
            border-left: 18px solid transparent;
            border-right: 18px solid transparent;
            border-bottom: 11px solid #fff;
            left: calc(88% - 55px);
        }
    }
}
</style>
